module.exports = __webpack_public_path__ + "md.7f6face5a112c8dd618a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/md.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/md.svg
// module chunks = styles